module.exports = __webpack_public_path__ + "static/media/IMessageScreenshot.df2b33e7.png";